import * as React from 'react';
import { compact, isEmpty } from 'lodash';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';
import { actions as notifyActions } from 'redux-notifications';

import * as storage from '@inqool/uas-web-core/es/utils/storage';
import ConfirmButton from '@inqool/uas-web-core/es/components/controls/ConfirmButton';

import { requestAction } from './_requestsActions';
import { operationalWarehouseRequestDeclinePermission } from 'src/permissions';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';

const View = ({ checkedItems, onClick, showDecline }) => {
  return (
    <>
      <ColumnManager agenda={Agenda.REQUESTS} />
      <div style={{ marginLeft: 5 }}>
        {[{ url: 'decline', label: 'Zamítnout', success: 'zamítnuty', error: 'zamítnout', show: showDecline }].map(
          ({ url, success, error, show = true, ...button }) =>
            show && (
              <ConfirmButton
                {...button}
                key={url}
                onClick={() => onClick(url, success, error)}
                disabled={isEmpty(checkedItems)}
                style={{ marginLeft: 10 }}
              />
            )
        )}
      </div>
    </>
  );
};

export const ActionBar = compose<any, {}>(
  connect(),
  withProps(() => {
    try {
      const permissions: Array<string> = JSON.parse(storage.get('permissions'));
      const showDecline = permissions.find(p => p === operationalWarehouseRequestDeclinePermission) ? true : false;
      return { showDecline };
    } catch (e) {
      return { showDecline: false };
    }
  }),
  withHandlers({
    onClick: ({ checkedItems, dispatch, refresh }) => async (url, success, error) => {
      try {
        const result = await Promise.all(checkedItems.map(({ id }) => requestAction(id, url)));

        if (compact(result).length === checkedItems.length) {
          dispatch(
            notifyActions.notifSend({
              message: `Žádosti byly úspěšně ${success}`,
              kind: 'success',
              dismissAfter: 6000
            })
          );
          refresh();
          return;
        }
      } catch (err) {
        console.error(err);
      }

      dispatch(
        notifyActions.notifSend({
          message: `Nepodařilo se ${error} žádosti`,
          kind: 'danger',
          dismissAfter: 6000
        })
      );
    }
  })
)(View);



// WEBPACK FOOTER //
// ./src/modules/requests/requestsGridButtons.tsx